<template>
  <div>
    <navigation></navigation>
      <keep-alive>
            <router-view></router-view>
      </keep-alive>
    <cusFooter></cusFooter>
  </div>
</template>

<script>
import navigation from './components/navigation.vue';
import cusFooter from './components/cusFooter.vue';

export default {
  name: 'layout',
  components:{ navigation,cusFooter },
  data () {
    return {}
  },
  methods: {},
}
</script> 

<style lang='less' scoped>

</style>
